module.exports = __webpack_public_path__ + "static/img/systherm_logo_default.496af69.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/systherm_logo_default.png
// module id = glaX
// module chunks = 1